import { DateTime } from 'luxon';

export const formatterDate = (cell: any) => {
  const locale =
    (window.navigator as any).userLanguage || window.navigator.language;
  // eslint-disable-next-line no-underscore-dangle
  const dateStr = cell._cell.value;
  let formattedDate = '';
  if (dateStr !== undefined && dateStr !== null) {
    const date = DateTime.fromISO(dateStr, { locale });
    if (date.isValid) {
      formattedDate = date.toLocaleString(DateTime.DATE_SHORT);
    }
  }
  return formattedDate;
};
